/**
 * Normalized backend origin including `/api/v1` (no trailing slash).
 */
export function getApiV1BaseUrl(): string {
  // Use || to handle empty string "" (which ?? would not catch)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  let base = (import.meta.env.VITE_API_URL || 'http://localhost:3000').trim();
  base = base.replace(/\/+$/, '');
  if (/\/api\/v1$/i.test(base)) return base;
  return `${base}/api/v1`;
}

/** API root with trailing slash for fetch URL joining. */
export function getApiV1RootUrl(): string {
  return `${getApiV1BaseUrl()}/`;
}
